import {useTranslation} from '@aboutyou/i18n';
import {useContactRoute, useHistory} from '@aboutyou/router';
import {useTrackFeature, useTrackOriginClick} from '@aboutyou/tracking';
import {
  Heading20,
  Text,
  mobileOnly,
  useShowToast,
} from '@aboutyou/ui-components';
import React from 'react';
import styled, {css} from 'styled-components';
import {VoteButton} from './VoteButton';

export const ArticleFeedback = () => {
  const {t} = useTranslation();
  const {push} = useHistory();
  const contact = useContactRoute();
  const trackFeature = useTrackFeature();

  const showToast = useShowToast();

  const trackOriginClick = useTrackOriginClick()('selfservice_contact_us');

  return (
    <Container>
      <TitleWithMargin>{t('Was this answer helpful?')}</TitleWithMargin>
      <VoteButtons data-testid="ArticleFeedbackVoteButtons">
        <VoteButton
          onClick={() => {
            // setIsFeedbackModalOpen(true);
            showToast({
              type: 'SUCCESS',
              content: (
                <ToastContent>
                  <span>{t('Thanks for the feedback!')}</span>
                  <Text size="px12" weight="light">
                    {t(
                      'Your feedback is very important to us. It helps us improve our service.',
                    )}
                  </Text>
                </ToastContent>
              ),
            });
            trackFeature({
              eventType: 'submit',
              label: 'self_service_flow_positive_feedback',
            });
          }}
          vote="up"
        >
          {t('Yes, my question was answered')}
        </VoteButton>
        <VoteButton
          onClick={() => {
            push(contact);
            trackFeature({
              eventType: 'submit',
              label: 'self_service_flow_negative_feedback',
            });
            trackOriginClick();
          }}
          vote="down"
        >
          {t('No, I still need help. Click here to contact us')}
        </VoteButton>
      </VoteButtons>
    </Container>
  );
};

const Container = styled.div`
  margin-top: 60px;
  display: flex;
  align-items: center;
  flex-direction: column;
`;

const TitleWithMargin = styled(Heading20)`
  margin-bottom: 40px;
`;

const VoteButtons = styled.div`
  max-width: 650px;
  display: flex;
  gap: 20px;

  ${mobileOnly(
    css`
      justify-content: stretch;
      flex-direction: column;
    `,
  )}
`;

const ToastContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
